import { ISerialSubmission, ISerialValidationData } from '@extendedWarranty/types/extendedWarranty';
import * as Yup from 'yup';

const mapRules = (map: Record<string, string>, rule: Yup.StringSchema<string, Yup.AnyObject, undefined, ''>) =>
    Object.keys(map).reduce((newMap, key) => ({ ...newMap, [key]: rule }), {});

const EditSerialNumbersSchema = ({
    initialValues,
    allSerialNumbers,
}: {
    initialValues: Record<string, ISerialValidationData>;
    allSerialNumbers: ISerialSubmission[];
}) =>
    Yup.lazy((map) =>
        Yup.object(
            mapRules(
                map,
                Yup.string()
                    .required('Required')
                    .test('isDifferentSN', (newValue, schema) => {
                        const values = { ...schema.parent };
                        delete values[schema.path];

                        if (
                            initialValues[schema.path].ValidationMessageError &&
                            newValue === initialValues[schema.path].SerialNumber &&
                            !initialValues[schema.path].ValidationMessageError?.includes('duplicate')
                        )
                            return schema.createError({
                                message: initialValues[schema.path].ValidationMessageError as string,
                                path: schema.path,
                            });

                        return true;
                    })
                    .test('isUnique', (newValue, schema) => {
                        const values = { ...schema.parent };
                        delete values[schema.path];

                        if (
                            Object.values(values).includes(newValue) ||
                            !!allSerialNumbers.find((sn) => (sn.edit_value || sn.SerialNumber) === newValue)
                        ) {
                            return schema.createError({ message: 'This serial number is already assigned' });
                        }

                        return true;
                    })
            )
        )
    );

export { EditSerialNumbersSchema };
